import { combineReducers } from 'redux'
import Auth from './Auth'
import Theme from './Theme'
import TableColumns from './tables/TableColumns'
import DeviceCounts from './DeviceCounts'
import KeyboardBuilder from './KeyboardBuilder'
import HomeScreenDesigner from './HomeScreenDesigner'
import versionMapReducer from './VersionMap'

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  tableColumns: TableColumns,
  deviceCounts: DeviceCounts,
  keyboardBuilder: KeyboardBuilder,
  homeScreenDesigner: HomeScreenDesigner,
  zebraApps: versionMapReducer
})

export default reducers
